/**
 * 更新自定义顶部导航栏的高度
 */
function updateCustomBarInfo () {
  return new Promise((resolve, reject) => {
    uni.getSystemInfo({
      success: (e) => {
        let statusBarHeight = 0
        let customBarHeight = 0

        statusBarHeight = e.statusBarHeight
        if (e.platform == 'android') {
          customBarHeight = e.statusBarHeight + 50
        } else {
          customBarHeight = e.statusBarHeight + 45
        };













        resolve({
          statusBarHeight,
          customBarHeight
        })
      },
      fail: (err) => {
        console.log("获取设备信息失败", err);
        reject()
      }
    })

  })
}

export default updateCustomBarInfo
